import { gql } from 'apollo-boost';

export const updateCustomPortalMutation = gql`
  mutation updateCustomPortalMutation($id: Int!, $template: JSONString!, $name: String) {
    updateCustomPortal(id: $id, template: $template, name: $name) {
      success
      id
    }
  }
`;
